export enum CardType {
    YellowCard = 1,
    RedCard = 2
}